import React from 'react';
import NewsComponentSkeleton from 'app/components/competitionModule/news/NewsComponentSkeleton';
import styled from 'styled-components';
import { NewsContainer } from 'app/components/competitionModule/news/commonStyles';
import SectionHeading from 'app/components/competitionModule/common/SectionHeading';
import { Skeleton } from '@mui/material';
const Wrapper = styled.div.withConfig({
  componentId: "sc-1jlgv8-0"
})(["display:flex;flex-direction:column;flex:1;"]);
export default function NewsBlockSkeleton(_ref) {
  let {
    animation
  } = _ref;
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "NewsBlockSkeleton",
    "data-sentry-source-file": "NewsBlockSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(SectionHeading, {
    "data-sentry-element": "SectionHeading",
    "data-sentry-source-file": "NewsBlockSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    width: 114,
    animation: animation,
    "data-sentry-element": "Skeleton",
    "data-sentry-source-file": "NewsBlockSkeleton.tsx"
  })), /*#__PURE__*/React.createElement(NewsContainer, {
    "data-sentry-element": "NewsContainer",
    "data-sentry-source-file": "NewsBlockSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(NewsComponentSkeleton, {
    "data-sentry-element": "NewsComponentSkeleton",
    "data-sentry-source-file": "NewsBlockSkeleton.tsx"
  }), /*#__PURE__*/React.createElement(NewsComponentSkeleton, {
    "data-sentry-element": "NewsComponentSkeleton",
    "data-sentry-source-file": "NewsBlockSkeleton.tsx"
  })));
}